import React from 'react';

import PropTypes from 'prop-types';
import { css } from 'styled-components';

import ProductCellPriceDetails from '~/shared/components/ProductCellPriceDetails';
import {
  ProductContext,
  SkeletonLine,
} from '~/techstyle-shared/react-components';

import useProductGridData from '../../hooks/useProductGridData';

const promoMessageStyles = css`
  ${({ theme }) => theme.pdpStyles.promoMessageStyles};
`;

const priceStyle = css`
  ${({ theme }) => theme.gridCellStyles.priceStyles}
`;

const ProductCardPricing = ({ product }) => {
  const { isProductPricingLoading } = useProductGridData();

  // Make sure to use isLoading instead of isFetching to avoid flickering on new batches of data on scroll
  // Works together with react-query's `keepPreviousData` option
  // TODO: use batch based loading state instead of blanket loading state
  if (isProductPricingLoading) {
    return <SkeletonLine width="100%" height="20px" />;
  }

  if (!product?.pricing) {
    return null;
  }

  const formattedProductForPriceDetails = {
    ...product,
    pricing: product.pricing,
    retailUnitPrice: product.pricing?.retail,
    defaultUnitPrice: product.pricing?.final,
    outletUnitPrice: product.pricing?.outlet,
    promos: product.pricing?.finalDetails,
    promoCode: product.pricing?.finalDetails?.promoCode,
  };

  // TODO: refactor to use a cleaner UI
  // TODO: [Nice to Have] update related images api to fetch pricing data

  return (
    <ProductContext product={formattedProductForPriceDetails}>
      <ProductCellPriceDetails
        product={formattedProductForPriceDetails}
        promoMessageStyles={promoMessageStyles}
        priceStyle={priceStyle}
      />
    </ProductContext>
  );
};

ProductCardPricing.propTypes = {
  product: PropTypes.shape({
    pricing: PropTypes.object,
    retailUnitPrice: PropTypes.number,
    defaultUnitPrice: PropTypes.number,
    outletUnitPrice: PropTypes.number,
    promos: PropTypes.object,
    promoCode: PropTypes.string,
  }),
};

export default ProductCardPricing;
